import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { ScrollToTop } from "./components/shared";
import { Toaster } from "./components/ui/toaster";
import HomePros from "./pages/HomePros";
import Home from "./pages/Home";
import Flooring from "./pages/Flooring";
import CategoryDetail from "./pages/CategoryDetail";
import MobileShowroom from "./pages/MobileShowroom";
import About from "./pages/About";
import Reviews from "./pages/Reviews";
import Estimate from "./pages/Estimate";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePros />} />
            <Route path="/floors" element={<Home />} />
            <Route path="/flooring" element={<Flooring />} />
            <Route path="/flooring/:slug" element={<CategoryDetail />} />
            <Route path="/mobile-showroom" element={<MobileShowroom />} />
            <Route path="/about" element={<About />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/estimate" element={<Estimate />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
